import { Paragraph } from '@zillow/constellation';
import React from 'react';
import { getApplicantText } from '../../../../../utils/listingApplicationListUtil';
import { getApplicationStatus, getNames } from './ApplicationCard.utils';
import useQueryVariables from '../../../../../hooks/useQueryVariables';
import UnstyledLink from '../../../../../components/UnstyledLink';
import { SectionNav } from '../../../../../components/SectionNav';
import { FULLSTORY_EXCLUDE } from '../../../../../constants/fullstory';

export default function ApplicationCard({ application }) {
  const { propertyId } = useQueryVariables();
  const { applicants } = application;
  return (
    <>
      <UnstyledLink to={`/rental-manager/applications/${application.id}?propertyId=${propertyId}`}>
        <SectionNav isClickable>
          <Paragraph fontType="finePrintHeading" fontColor="textMedium">
            {getApplicantText({ applicants })}
          </Paragraph>
          <Paragraph fontType="body" fontColor="textDark" className={FULLSTORY_EXCLUDE}>
            {getNames(applicants)}
          </Paragraph>
          <Paragraph fontType="smallBody" fontColor="textMedium">
            {getApplicationStatus(application)}
          </Paragraph>
        </SectionNav>
      </UnstyledLink>
    </>
  );
}
